import React from "react";

import { format } from "date-fns";

import { Box } from "@chakra-ui/react";

import { InfoPessoa } from "../Equipe/InfoPessoa";

import Group from "../../../pages/ServicosAcolhimento/Visualizar/Group";

export const PessoaEmCumprimento = ({ data }) => {
  const columns = [
    {
      Header: "Atividades Desenvolvidas",
      accessor: "atividadesDesenvolvidas",
      Cell: (props) => {
        return (
          <span
            title={props.value}
            style={{
              wordBreak: "break-word",
            }}
          >
            {props.value}
          </span>
        );
      },
    },
    {
      Header: "Início das atividades",
      accessor: "dataInicioAtividades",
      Cell: (props) => {
        return (
          <span>{props.value ? format(props.value, "dd/MM/yyyy") : ""}</span>
        );
      },
    },
    {
      Header: "Término das Atividades",
      accessor: "dataTerminoAtividades",
      Cell: (props) => {
        return (
          <span>{props.value ? format(props.value, "dd/MM/yyyy") : ""}</span>
        );
      },
    },
    {
      Header: "Data do Documento",
      accessor: "dataDocumento",
      Cell: (props) => {
        return (
          <span>{props.value ? format(props.value, "dd/MM/yyyy") : ""}</span>
        );
      },
    },
  ];

  return data ? (
    <Box display="block">
      <Box className="break-page">
        <Group
          bgColor="#DDEBEA"
          title="Pessoa em Cumprimento de Pena"
          mt="15px"
          py="12px"
          mtDivider="5px"
        >
          {data
            .sort((a, b) => a.nome.localeCompare(b.nome, "pt-BR"))
            .map((pessoa, index) => (
              <Box key={index}>
                <InfoPessoa
                  name={pessoa.nome}
                  data={[pessoa]}
                  columns={columns}
                />
              </Box>
            ))}
        </Group>
      </Box>
    </Box>
  ) : (
    <Box display="block">
      <Group
        bgColor="#DDEBEA"
        title="Pessoa em Cumprimento de Pena"
        mt="15px"
        py="12px"
        mtDivider="5px"
      />
    </Box>
  );
};
